module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAgMAAACdGdVrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAJUExURSe7u0dwTCi5uUe04x4AAAADdFJOUyUAEjdJMZ0AAABQSURBVAjXYwgNbWAKDWUIDWBgUAVSDQwMTKEMYQxAMJUhAkSpMgSAKFaGBBDFyOAAoRpAFBMD8QCqwQHJFE6Y0VCLoNZCHREKFGUFUmAHAgCeDA3VBHIIVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership/upperRightDecor@3x.png
// module id = 1809
// module chunks = 0